var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.root},_vm._l((_vm.linesCount),function(n){return _c('LinesLoader',{key:("loader__" + n),class:_vm.css.lines})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }